import { Rule } from 'antd/lib/form';
import React, { useMemo } from 'react';
import { TParametersOfApkType } from 'types';
import { parametersOfApkType } from 'appConstants';
import FormSelect from 'components/Select/FormSelect';
import { ISelectOption } from 'components/Select/types';
import { useTranslation } from 'react-i18next';

interface IParameterOfApkTypeSelect {
	setParameterOfApkType: (value: Nullable<TParametersOfApkType>) => void;
}

const ParameterOfApkTypeSelect: React.FC<IParameterOfApkTypeSelect> = ({ setParameterOfApkType }) => {
	const { t } = useTranslation('error');
	const { t: tForm } = useTranslation('form');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('selectParameterOfApkType') }], [t]);

	const mappedOptions = useMemo<ISelectOption[]>(() => {
		return parametersOfApkType.map((el) => ({
			id: el.parametersOfApkTypeID,
			name: tForm(el.parametersOfApkTypeName),
		}));
	}, [tForm]);

	return (
		<FormSelect
			testId="ParameterOfApkTypeSelect"
			name="parameterOfApkType"
			label="applicationTypeLabel"
			options={mappedOptions}
			onChange={setParameterOfApkType}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(ParameterOfApkTypeSelect);
